export default __webpack_public_path__ + "static/Group 622-0ba455907dd3980f31acb8873edb75f9.png";